import React from "react";

export default function OrderDetils({ BookingDetails }) {
  return (
    <div className="card-body">
      <table className="table table-responsive">
        <thead>
          <th>SN</th>
          <th>Product</th>
          <th>Qty</th>
          <th>Rate</th>
          <th>free</th>
          <th>Sub-Total</th>
        </thead>
        <tbody>
          {BookingDetails ? (
            BookingDetails.product.map((prd, i) => (
              <tr key={i}>
                <td>{i + 1}</td>
                <td>
                  {prd}
                  <small> {BookingDetails.note[i]}</small>
                </td>
                <td>{BookingDetails.qty[i]}</td>
                <td>{BookingDetails.rate[i]}</td>
                <td>{BookingDetails.free[i]}</td>
                <td>{BookingDetails.rate[i] * BookingDetails.qty[i]}</td>
              </tr>
            ))
          ) : (
            <h1>Cart Seems Empty!</h1>
          )}
        </tbody>
      </table>
      <table className="table table-condensed">
        <tbody>
          <tr>
            <th>Total</th>
            <th>{BookingDetails.total_amount}</th>
          </tr>
          <tr>
            <th>Advance</th>
            <th>{BookingDetails.advance_amount}</th>
          </tr>
          <tr>
            <th>Balance</th>
            <th>{BookingDetails.balance_amount}</th>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
